import { render, staticRenderFns } from "./basicData.vue?vue&type=template&id=85821ec6&scoped=true&"
import script from "./basicData.vue?vue&type=script&lang=js&"
export * from "./basicData.vue?vue&type=script&lang=js&"
import style0 from "./basicData.vue?vue&type=style&index=0&id=85821ec6&scoped=true&lang=css&"
import style1 from "./basicData.vue?vue&type=style&index=1&lang=css&"
import style2 from "./basicData.vue?vue&type=style&index=2&id=85821ec6&scoped=true&lang=css&"
import style3 from "./basicData.vue?vue&type=style&index=3&id=85821ec6&scoped=true&lang=css&"
import style4 from "./basicData.vue?vue&type=style&index=4&id=85821ec6&scoped=true&lang=css&"
import style5 from "./basicData.vue?vue&type=style&index=5&id=85821ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85821ec6",
  null
  
)

export default component.exports